/**
 * Pretty-printed JSON for previews: strings pass through (null when blank), other values are
 * stringified with 2-space indent; null/undefined or unserialisable values give null.
 */
export function jsonPreview(value: unknown): string | null {
  if (value == null) return null;
  if (typeof value === 'string') return value.trim() ? value : null;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return null;
  }
}
